import { render, staticRenderFns } from "./edit-column.vue?vue&type=template&id=63570a4e&"
import script from "./edit-column.vue?vue&type=script&lang=js&"
export * from "./edit-column.vue?vue&type=script&lang=js&"
import style0 from "./edit-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports